import React from "react";
import { NewDynamicTab } from "../../../components/Page";
import { RuvnlTitle } from "../components";
import { TabSwitcher } from "../Raj_Dashboard";
import RajUpload from "./Upload";

const UploadComponent = () => {
  return (
    <NewDynamicTab
      header="Upload Form"
      showDates={false}
      middleComponent={<RuvnlTitle />}
      headerPrefixComponent={<TabSwitcher />}
      tabs={{
        Upload: <RajUpload />,
      }}
    />
  );
};

export default UploadComponent;
